import T from 'prop-types';
import React from 'react';

class DynamicFormErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidUpdate(prevProps) {
    const childrenChanged = this.props.children !== prevProps.children;

    if (childrenChanged && this.state.error) {
      this.setState({ error: null });
    }
  }

  render() {
    const {
      detail,
      error: _error,
      isRoot = false,
      showStackTrace = false,
      title,
    } = this.props;

    const { error = _error } = this.state;

    if (error) {
      const style = {
        overflow: 'scroll',
        padding: '2px 5px',
        ...(!isRoot
          ? {
              border: '1px dashed red',
              margin: '15px 0',
            }
          : {}),
      };

      return global.__DEV__ ? (
        <div style={style}>
          {title && <p>{title}</p>}
          <pre style={{ color: 'red', whiteSpace: 'pre-line' }}>
            {detail && `${detail}\n\n`}
            {String(error[showStackTrace ? 'stack' : 'message'])}
          </pre>
        </div>
      ) : null;
    }

    return this.props.children;
  }
}

DynamicFormErrorBoundary.propTypes = {
  title: T.string,
  detail: T.string,
  children: T.node,
  showStackTrace: T.bool,
  error: T.instanceOf(Error),
  isRoot: T.bool,
};

const main = global.__DEV__
  ? DynamicFormErrorBoundary
  : ({ children }) => children;

main.displayName = 'DynamicFormErrorBoundary';

export { main as DynamicFormErrorBoundary };
